import styled from 'styled-components';
import {Label} from '../../atoms/Label';
import {OnSurface} from '../../Colors';

export default {
	ContentLayout : styled.span`
		display: flex;
		flex-wrap: wrap;
		border: 1px dotted gray;
		padding:0.5rem;
	`,
	AnswerLayout : styled.div`
		padding-left: 1rem;
		padding-right: 1rem;
	`,
	LabelLayout : styled(Label)`
		margin-bottom : 0.5rem;
		color : ${OnSurface};
	`,
};